import React, { useEffect, useState } from 'react'
import DealerModel from './models/DealerModel';
import FileUploadModal from '../../shared/file-upload/FileUploadModal';
import FileList from '../../shared/file-upload/FileList';

function AddDealer({ sendDataToParent, onLoad, isOpen }) {
  const [dealerData, setDealerData] = useState(() => new DealerModel());
  const [addressData, setAddressData] = useState({});
  const [pendingFiles, setPendingFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    setDealerData((prev) => ({
      ...prev,
      [name]: value,
      ...addressData,
    }));
  }

  function handleAddressChange(e) {
    const { name, value } = e.currentTarget;
    setAddressData((prev) => {
      const updated = { ...prev, [name]: value };
      setDealerData((prevData) => ({ ...prevData, ...updated }));
      return updated;
    });
  }

  const handleUploadConfirm = ({ category, files, title }) => {
    const additions = (files || []).map((file, idx) => ({
      key: `pending-${Date.now()}-${idx}`,
      OriginalName: file.name,
      FileTitle: title || '',
      FileCategory: category,
      FileSizeKB: Math.max(1, Math.round(file.size / 1024)),
      file,
      status: 'Pending upload'
    }));
    setPendingFiles((prev) => [...prev, ...additions]);
  };

  const handleRemovePending = (file) => {
    setPendingFiles((prev) => prev.filter((f) => f.key !== file.key));
  };

  useEffect(() => {
    if (onLoad) {
      onLoad(new DealerModel());
    }
  }, [onLoad]);

  useEffect(() => {
    if (!isOpen) {
      setPendingFiles([]);
      setAddressData({});
      setDealerData(new DealerModel());
    }
  }, [isOpen]);

  useEffect(() => {
    setDealerData((prev) => ({ ...prev, PendingFiles: pendingFiles }));
  }, [pendingFiles]);

  useEffect(() => {
    if (sendDataToParent) {
      sendDataToParent(dealerData);
    }
  }, [dealerData, sendDataToParent]);

  return (
    <>

      <div className="row">
        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Dealer Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="DealerName"
            onChange={handleChange}
          />
        </div>

         <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Mobile No
          </label>
          <input
            type="text"
            className="form-control"
            name="MobileNumber"
            onChange={handleChange}
          />
        </div>

        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            onChange={handleChange}
          />
        </div>

        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Address 1
          </label>
          <textarea
            className="form-control"
            name="AddressLine1"
            rows="1"
            onChange={handleAddressChange}
          />
        </div>

        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Address 2
          </label>
          <textarea
            className="form-control"
            name="AddressLine2"
            rows="1"
            onChange={handleAddressChange}
          />
        </div>

        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Address 3
          </label>
          <textarea
            className="form-control"
            name="AddressLine3"
            rows="1"
            onChange={handleAddressChange}
          />
        </div>

        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">City</label>
          <input
            type="text"
            className="form-control"
            name="City"
            onChange={handleAddressChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">State</label>
          <input
            type="text"
            className="form-control"
            name="State"
            onChange={handleAddressChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">Country</label>
          <input
            type="text"
            className="form-control"
            name="Country"
            onChange={handleAddressChange}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">Pin No</label>
          <input
            type="text"
            className="form-control"
            name="PinNumber"
            onChange={handleAddressChange}
          />
        </div>

      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Attachments</h6>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowUploadModal(true)}>
          Upload Files
        </button>
      </div>
      <FileList files={pendingFiles} showRemove={true} showDownload={false} onRemove={handleRemovePending} />

      <FileUploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        categories={["Dealer", "KYC", "Contract", "Other"]}
        onConfirm={handleUploadConfirm}
      />
    </>
  )
}

export default AddDealer